import { useState, useMemo, useEffect, useRef } from 'react';
import { X, Search } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useProducts } from '../context/ProductsContext';
import { track } from '../analytics/track';

export default function SearchModal({ open, onClose }) {
  const { products } = useProducts();
  const [q, setQ] = useState('');
  const debounceRef = useRef(null);
  const results = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return products.filter(p => !p.hidden).slice(0, 6);
    return products.filter(p => !p.hidden && (p.name.toLowerCase().includes(t) || p.fragranceLabel.toLowerCase().includes(t) || p.categoryLabel.toLowerCase().includes(t)));
  }, [products, q]);

  // Track search terms (debounced) for admin analytics
  useEffect(() => {
    const t = q.trim();
    if (t.length < 2) return;
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      track('search', { element_name: t.toLowerCase(), value: results.length });
    }, 900);
    return () => clearTimeout(debounceRef.current);
  }, [q]); // eslint-disable-line

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50" data-testid="search-modal">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="absolute top-0 left-0 right-0 liquid-glass-panel border-x-0 border-t-0 rounded-b-[2rem] shadow-xl">
        <div className="container-essenya py-6">
          <div className="flex items-center gap-3 border-b border-essenya-border pb-4">
            <Search size={20} strokeWidth={1.5} />
            <input
              autoFocus value={q} onChange={e => setQ(e.target.value)}
              placeholder="Cerca prodotti, fragranze..."
              data-testid="search-input"
              className="flex-1 outline-none text-lg bg-transparent"
            />
            <button onClick={onClose} data-testid="search-close" aria-label="Chiudi"><X size={22} strokeWidth={1.5} /></button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 pt-6">
            {results.map(p => (
              <Link key={p.id} to={`/prodotto/${p.slug}`} onClick={() => { track('search_result_click', { product_id: p.id, element_name: q.trim().toLowerCase() }); onClose(); }} className="flex gap-3 p-2 rounded-lg hover:bg-essenya-surface2 transition" data-testid={`search-result-${p.id}`}>
                <img src={p.images[0]} alt="" className="w-16 h-20 rounded-md object-contain p-1 bg-essenya-surface2" />
                <div className="text-sm">
                  <p className="font-medium">{p.name}</p>
                  <p className="text-essenya-text text-xs">{p.fragranceLabel}</p>
                  <p className="font-display text-sm mt-1">{p.price.toFixed(2).replace('.', ',')}€</p>
                </div>
              </Link>
            ))}
            {results.length === 0 && <p className="text-essenya-text col-span-full py-8 text-center">Nessun risultato</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
